import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DtoImportObjectContext} from "../dto/dto.import.object.context";
import {MvsCoreService} from "../service/mvs-core.service";
import {NavigationItem} from "../dto/navigation/navigation-item";
import {PageBehaviorInterface} from "../service/page/page-behavior.interface";
import {PageHeaderConfig} from "../service/page/page-header-config.interface";
import {MenuItem} from "primeng/api";

import {Subscription} from "rxjs";
import {UiPageUserService} from "../../ui/service/api/ui-page-user.service";
import {UiPageTypeEnum} from "../command/enum/ui-page-type.enum";

@Component({
    selector: 'mvs-page',
    template: 'PageComponent',
    standalone: false
})
export class PageComponent implements PageBehaviorInterface, OnInit, OnDestroy, OnChanges {

  importObjectContextDto: DtoImportObjectContext = new DtoImportObjectContext([]);

  protected initialized: boolean;
  protected busy: boolean;

  activeNavigationItem: NavigationItem;
  navigationItems: NavigationItem[]
  paramSubscription: Subscription;

  defaultLabel: string;

  availableItems = ['Item 1', 'Item 2', 'Item 3', 'Item 4'];
  selectedItems = [];

  @ViewChild('headerTemplate', { static: true }) headerTemplate: TemplateRef<any>; //in case the header is html block not a component

  constructor(
    protected route: ActivatedRoute,
    protected coreService: MvsCoreService,
    // private titleService: Title
  ) {
  }


  // drop(event: CdkDragDrop<string[]>) {
  //   console.log(event);
  //   if (event.previousContainer === event.container) {
  //     console.log("move");
  //     moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  //   } else {
  //     console.log("transfer");
  //     transferArrayItem(event.previousContainer.data,
  //         event.container.data,
  //         event.previousIndex,
  //         event.currentIndex);
  //   }
  // }
  //
  // dropSelected(event: CdkDragDrop<string[]>) {
  //   console.log(event);
  //   if (event.previousContainer === event.container) {
  //     console.log("move");
  //     moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  //   } else {
  //     console.log("transfer");
  //     transferArrayItem(event.previousContainer.data,
  //         event.container.data,
  //         event.previousIndex,
  //         event.currentIndex);
  //   }
  // }


  /**
   * Initialization.
   */
  ngOnInit(): void {
    this.preInit();

    // log the visit
    this.logVisit();

    //register page
    this.setActivePage();

    //set page title in browser tab
    this.setActiveTitle();

    // update page context
    this.updatePageContext();

    this.subscribeToParams();

  }

  protected updatePageContext() {
    // regular page, no active object exists
    this.coreService.getPageContextService().removeActiveObject();
  }

  subscribeToParams() {


    this.paramSubscription = this.route.queryParams.subscribe(params => {
      const navItem = params['navItem'];

      if (!this.navigationItems?.length) {
        return
      }

      if (navItem) {
        this.activeNavigationItem = this.navigationItems.find(item => item.action == navItem);
      } else {
        this.activeNavigationItem = this.navigationItems.find(item => item.default == true);
      }

      this.postNavigationSelection();

    });
  }

  postNavigationSelection() {}

  /**
   * Log Visit.
   * @protected
   */
  protected logVisit() {

    const uiPageUserService = <UiPageUserService><unknown>this.coreService.getCrudService("ui.UiPageUser");
    uiPageUserService.pageVisit(this.route?.routeConfig?.path, this?.defaultLabel, UiPageTypeEnum.regular);

  }

  protected setActivePage() {
    this.coreService.getPageService().setActivePage(this);
  }

  protected setActiveTitle() {
    this.coreService.updatePageTitle(this.defaultLabel);
  }


  protected preInit() {

  }

  setBreadcrumbItems(items: MenuItem[]) {
    this.coreService.getPageService().breadcrumbItems = items;
  }

  setHomeBreadcrumb(item: MenuItem) {
    this.coreService.getPageService().home = item;
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnDestroy() {
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe();
    }

    this.coreService.getPageService().notifyPageDestroyed(this);

  }

  isBreadcrumbVisible(): boolean {
    return false;
  }

  isConfigurationPage(): boolean {
    return false;
  }

  isNavComponent(): NavigationItem[] {
    return null;
  }

  isBreadcrumbComponent(): MenuItem[] {
    return null;
  }

  // updateTitle(pageTitle: string) {
  //   this.titleService.setTitle(pageTitle);
  // }

  isTopBarVisible(): boolean {
    return true;
  }

  isPaddingVisible(): boolean {
    return true;
  }

  getPageHeaderConfig(): PageHeaderConfig {
    return null;
  }

}
